import React, { useContext, useState } from 'react';
import { Accordion } from '../../../ui/Accordion';
import { AddValueForm } from '../../CreateScriptPage';
import { AdditionalFieldProps } from './types';
import { YesNoModal } from '../../../ui/Modals';
import { useDeleteAdditionalFieldMutation } from '../../../../store/api';
import { Reorder, useDragControls } from 'framer-motion';
import s from './AdditionalFields.module.scss';
import diff from '../../../../libs/htmlDiff';
import { AuthContext } from '../../../../context/Auth/AuthContext';
import { Roles } from '../../../../constants';

const AdditionalField: React.FC<AdditionalFieldProps> = ({
  field,
  changeOrders,
  isShow,
  withoutFuncs,
  editAdditionalField,
  fieldsRef,
  changes,
  ai_keys
}) => {
  const { id, name, text } = field;

  const { user } = useContext(AuthContext);

  const [deleteAdditionalField] = useDeleteAdditionalFieldMutation();
  const [deleteModal, setDeleteModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const dragControls = useDragControls();

  const changedValue = (field: 'name' | 'text') => {
    const changeType = changes?.[1]
      ? field === 'text'
        ? changes?.[1]
        : changes?.[0]
      : changes?.[0];

    const result = changeType && diff(changeType.old_value, changeType.new_value);

    if (changeType?.field === field) {
      return result;
    } else return undefined;
  };

  const handleOpenDeleteModal = () => {
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleDeleteAdditionalField = () => {
    deleteAdditionalField(id);
    setDeleteModal(false);
  };

  const handleSetEditMode = () => {
    setEditMode(true);
  };

  const handleCancelEditMode = () => {
    setEditMode(false);
  };

  const fieldTitle = changedValue('name') ?? name;
  const fieldContent =
    user?.role !== Roles.MANAGER && field.ai_key
      ? `AI-key: ${field.ai_key} \n ${changedValue('text') ?? text}`
      : `${changedValue('text') ?? text}`;

  return !editMode ? (
    <Reorder.Item
      value={field}
      dragListener={false}
      dragControls={dragControls}
      onDragEnd={changeOrders}
    >
      <div className={s.additionalField} ref={(ref) => fieldsRef?.current?.set(id, ref)}>
        <Accordion
          title={fieldTitle}
          content={fieldContent}
          isShow={isShow}
          onEdit={handleSetEditMode}
          onRemove={handleOpenDeleteModal}
          withoutFuncs={withoutFuncs}
          dragControls={dragControls}
          isDragNDrop
        />
        <YesNoModal
          isDelete
          title={field.name}
          open={deleteModal}
          onClose={handleCloseDeleteModal}
          onAgree={handleDeleteAdditionalField}
        />
      </div>
    </Reorder.Item>
  ) : (
    <AddValueForm
      addAdditionalField={() => null}
      editAdditionalField={editAdditionalField}
      onClose={handleCancelEditMode}
      editedAdditionalField={field}
      script_id={field.script_id}
      ai_keys={ai_keys}
    />
  );
};

export default AdditionalField;
